export default __webpack_public_path__ + "static/media/ItalicIcon.965e262b.svg";